module.exports = __webpack_public_path__ + "74ca69fbba2350b656998773d91958de.png";